module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('main-header', _vm._b({}, 'main-header', {
    user: _vm.user,
    productsInCart: _vm.productsInCart
  })), _c('router-view'), _c('main-footer', _vm._b({}, 'main-footer', {
    user: _vm.user,
    productsInCart: _vm.productsInCart
  })), (!_vm.user) ? _c('login', {
    on: {
      "signInGoogle": _vm.getUserGoogle
    }
  }) : _vm._e(), (_vm.user) ? _c('profile', _vm._b({}, 'profile', {
    user: _vm.user
  })) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-5c1bcdfa"}!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 128
// module chunks = 0